import { STATE_LOGIN } from "./pagecomponents/Login/AuthForm";
import GAListener from "./components/GAListener";
import { EmptyLayout, LayoutRoute, MainLayout } from "./components/Layout";
import PageSpinner from "./components/PageSpinner";
import AuthPage from "./pages/AuthPage";
import React, { useEffect } from "react";
import componentQueries from "react-component-queries";
import { useDispatch } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./styles/reduction.scss";
import {
  getUser,
  ProtectedComponents,
  getAccessToken,
  isSuperAdmin,
} from "./utlis";
import { setUser } from "./pagecomponents/Login/action";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
//for admin
import AdminApp from "./admin/App";
// for ward
const FamilyProfileTable = React.lazy(() =>
  import("./pagecomponents/FamilyProfile/Components/FamilyProfileTable")
);
const DashboardPage = React.lazy(() => import("./pages/Homepage"));
const PersonalProfile = React.lazy(() => import("./pages/PersonalProfile"));
const ViewAll = React.lazy(() =>
  import("./pagecomponents/Notification/ViewAllTest")
);
const ViewProfile = React.lazy(() => import("./components/Layout/ViewProfile"));
const FamilyDirectory = React.lazy(() =>
  import("./pagecomponents/FamilyProfile/Components/FamilyProfileTable")
);
const DataDirectory = React.lazy(() => import("./pages/DataDirectory"));
const WardSearch = React.lazy(() =>
  import("./pagecomponents/WardPortal1/components/WardSearch")
);

const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split("/").pop()}`;
};
const getAdminBasename = () => {
  return `/${process.env.PUBLIC_URL.split("/amdin").pop()}`;
};
toast.configure({
  autoClose: 5000,
  newestOnTop: true,
  hideProgressBar: true,
  closeButton: false,

  bodyClassName: "toastBody",
  position: "bottom-right",
});
const App = (props) => {
  console.log(isSuperAdmin(), "app props", props);
  const dispatch = useDispatch();
  const { user, group } = useSelector((state) => state.LoginReducer);
  useEffect(() => {
    if (getAccessToken() && getUser() !== null) {
      const user = getUser();
      dispatch(setUser(user));
    }
  }, [dispatch]);
  console.log("group", group);
  return !isSuperAdmin() ||
    group === "PALIKAADMIN" ||
    group === "DISTRICTADMIN" ||
    group === "WARDADMIN" ? (
    <BrowserRouter basename={getBasename()}>
      <GAListener>
        <Switch>
          <LayoutRoute
            exact
            path="/login"
            layout={EmptyLayout}
            component={(props) => (
              <AuthPage {...props} authState={STATE_LOGIN} />
            )}
          />
          {console.log("check", getAccessToken(), getUser())}

          <MainLayout breakpoint={props.breakpoint}>
            <React.Suspense fallback={<PageSpinner />}>
              <ProtectedComponents>
                {console.log("isPalika")}
                <Route exact path="/" component={DashboardPage} />
                <Route exact path="/personal" component={PersonalProfile} />
                <Route exact path="/viewall" component={ViewAll} />
                <Route exact path="/familydir" component={FamilyProfileTable} />
                <Route exact path="/datadir" component={DataDirectory} />
                <Route exact path="/profile" component={WardSearch} />
                <Route exact path="/test" component={FamilyProfileTable} />
                <Route exact path="/viewprofile" component={ViewProfile} />
              </ProtectedComponents>
            </React.Suspense>
          </MainLayout>
          <Redirect to="/" />
        </Switch>
      </GAListener>
    </BrowserRouter>
  ) : (
    <AdminApp />
  );
};
const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: "xs" };
  }
  if (576 < width && width < 767) {
    return { breakpoint: "sm" };
  }
  if (768 < width && width < 991) {
    return { breakpoint: "md" };
  }
  if (992 < width && width < 1199) {
    return { breakpoint: "lg" };
  }
  if (width > 1200) {
    return { breakpoint: "xl" };
  }
  return { breakpoint: "xs" };
};
export default componentQueries(query)(App);
